import { render, staticRenderFns } from "./CheckBoxes.vue?vue&type=template&id=24f26080&lang=pug&"
import script from "./CheckBoxes.vue?vue&type=script&setup=true&lang=js&"
export * from "./CheckBoxes.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports